import { useMemo } from 'react';

import { cartItemDisplayName, centsToDollar, toTitleCase } from 'core/Utils';
import { DateTime } from 'luxon';
import { ConsumerCartItem } from 'store/Api';
import { Card, Divider, Group, ImageMantine, Stack, Text, Title } from 'ui';

type Props = {
  cartItem: ConsumerCartItem;
};
const PurchaseDetails = ({ cartItem }: Props) => {
  const optionKeys = useMemo(() => Object.keys(cartItem?.options || {}), [cartItem?.options]);

  return (
    <Stack>
      <Title order={2} visibleFrom="md">{`${cartItem.store_item.name} Purchase`}</Title>

      <Card radius={8} p={0} bd="1px solid gray.1">
        <Stack gap={0}>
          <Stack p={'md'}>
            <Group align="top">
              <ImageMantine
                w={{ base: '61px', md: '101px' }}
                src={cartItem.store_item.images?.[0]?.url}
                radius={'sm'}
              />

              <Stack gap={0} style={{ flexGrow: 1 }}>
                <Text fz="sm" fw={500}>
                  {cartItemDisplayName(cartItem)}
                </Text>
                {cartItem?.cart?.purchased_at && (
                  <Text c="gray" fz={12}>
                    Purchase Date:{' '}
                    {DateTime.fromISO(cartItem?.cart?.purchased_at).toFormat('MM/dd/yy')}
                  </Text>
                )}
              </Stack>
              <Text fz={14} fw={600}>
                {centsToDollar(cartItem?.total)}
              </Text>
            </Group>
          </Stack>
          {optionKeys.length > 0 && (
            <>
              <Divider color="gray.1" />
              <Stack p="md">
                {optionKeys.map((key) => (
                  <Stack gap="xs" key={key}>
                    <Text fz={14} fw={600}>
                      {toTitleCase(key)}
                    </Text>
                    <Text fz={14} c="gray">
                      {cartItem?.options[key]}
                    </Text>
                  </Stack>
                ))}
              </Stack>
            </>
          )}
        </Stack>
      </Card>
    </Stack>
  );
};

export { PurchaseDetails };
